import { defineStore } from "pinia";
import { useCompletionAssignmentStore } from "%/dynamic-component-editor/stores/completion-assignment-store";

const STATUS_SLOT_PREFIX = "status:";
const TOGGLE_SLOT_PREFIX = "toggle:";

export const useCompletionComponentsStore = defineStore("completion-components-store", {
  state: () => ({
    loadedPublicationId: 0,
  }),
  getters: {
    componentIdsBySlot() {
      return useCompletionAssignmentStore().assignmentsByPublication[this.loadedPublicationId] ?? {};
    },
    componentIds() {
      return Object.values(this.componentIdsBySlot)
          .map(dynamicComponentId => Number(dynamicComponentId))
          .filter(dynamicComponentId => dynamicComponentId > 0);
    },
    isCompletionComponentId() {
      return id => this.componentIds.includes(Number(id));
    },
    statusComponentIds() {
      return this.componentIdsForSlotPrefix(STATUS_SLOT_PREFIX);
    },
    toggleComponentIds() {
      return this.componentIdsForSlotPrefix(TOGGLE_SLOT_PREFIX);
    },
    componentIdsForSlotPrefix() {
      return slotPrefix => Object.entries(this.componentIdsBySlot)
          .filter(([slotKey]) => slotKey.startsWith(slotPrefix))
          .map(([, dynamicComponentId]) => Number(dynamicComponentId))
          .filter(dynamicComponentId => dynamicComponentId > 0);
    },
    completionSlotForComponentName() {
      return componentName => {
        const normalized = String(componentName || "")
            .toLowerCase()
            .replace(/[_–-]+/g, " ")
            .replace(/\s+/g, " ")
            .trim();
        if (normalized === "status" || normalized.endsWith(" status")) {
          return "status";
        }
        if (normalized === "toggle" || normalized.endsWith(" toggle")) {
          return "toggle";
        }
        return "";
      };
    },
  },
  actions: {
    ensureCompletionComponentIds(publicationId) {
      const pubId = Number(publicationId) || 0;
      if (!pubId) {
        return;
      }
      this.loadedPublicationId = pubId;
      return useCompletionAssignmentStore().ensureAssignments(pubId);
    },
  },
});
